import styled from "styled-components";
import { theme } from "styles/theme";

export const ModesSidebar = styled.div`
  background-color: transparent;
  border: none;
  box-shadow: none;
  height: fit-content;
`;

export const ModesTitle = styled.h3`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0 0 0.625rem;
  margin: 0 0 0.75rem;
  background-color: transparent;
  color: ${theme.colors.textPrimary};
  border-bottom: 1px solid ${theme.colors.border};
  font-weight: ${theme.fontWeights.medium};
  font-size: 0.95rem;
`;

export const ModeToggle = styled.div`
  display: flex;
  padding: 0.25rem;
  margin: 0 0 1.25rem;
  border-radius: ${theme.borderRadius.small};
  background-color: ${theme.colors.bgLight};
  border: 1px solid ${theme.colors.border};
`;

export const ModeToggleOption = styled.div<{ $active: boolean }>`
  flex: 1;
  text-align: center;
  padding: 0.625rem 0.5rem;
  min-height: 44px;
  border-radius: 3px;
  font-weight: ${(props) => (props.$active ? 600 : 400)};
  background-color: ${(props) =>
    props.$active ? theme.colors.tertiary : "transparent"};
  color: ${(props) =>
    props.$active ? theme.colors.onTertiary : theme.colors.textPrimary};
  box-shadow: none;
  transition: background-color 0.15s ease, color 0.15s ease;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: ${(props) =>
      props.$active ? theme.colors.tertiaryDark : theme.colors.surface};
    color: ${(props) =>
      props.$active ? theme.colors.onTertiary : theme.colors.textPrimary};
  }
`;

export const ModesList = styled.div`
  padding: 0;
`;

export const ModesCategory = styled.div`
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const CategoryTitle = styled.h4`
  color: ${theme.colors.textSecondary};
  font-size: 0.8rem;
  font-weight: ${theme.fontWeights.medium};
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin: 0.75rem 0 0.5rem;
  padding: 0;
  border: none;
`;

export const CategoryModes = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 6px;
`;

export const ModeButton = styled.div<{ $active: boolean; disabled?: boolean }>`
  padding: 0.5rem 0.25rem;
  min-height: 40px;
  border-radius: 3px;
  text-align: center;
  font-size: 0.8rem;
  font-weight: ${(props) => (props.$active ? 600 : 400)};
  background-color: ${(props) =>
    props.$active ? theme.colors.tertiary : theme.colors.bgLight};
  color: ${(props) =>
    props.$active ? theme.colors.onTertiary : theme.colors.textPrimary};
  border: 1px solid
    ${(props) =>
      props.$active ? theme.colors.tertiary : theme.colors.border};
  transition: background-color 0.15s ease, border-color 0.15s ease,
    color 0.15s ease;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};

  &:hover {
    border-color: ${theme.colors.tertiary};
    background-color: ${(props) =>
      props.$active ? theme.colors.tertiaryDark : theme.colors.surface};
  }
`;

export const BoostModeButton = styled(ModeButton)``;
